module.exports = __webpack_public_path__ + "img/tap.0dddc9a8.gif";